import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const submitFeedback = feedback => ({
    type: types.REQUEST_SUBMIT_FEEDBACK,
    payload: feedback
});
